import { render, staticRenderFns } from "./EditSupplierQuality.vue?vue&type=template&id=394a34bb&"
import script from "./EditSupplierQuality.vue?vue&type=script&lang=js&"
export * from "./EditSupplierQuality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports